import React from 'react';

const EstadoEliminado = (props) => {
    return (
        <div className="dropdown state pull-right" id={"state-delete-" + props.ID}>
            <button type="button" data-toggle="dropdown" data-target={"state-delete-" + props.ID}
                className="btn btn-cta btn-sm btn-deleted">ELIMINADO</button>
            <ul className="dropdown-menu no-padding-bottom">
                <li className="bottom-separator-xs">
                    <p>{"Eliminado por " + props.Nombre + " el " + props.Fecha + " a las " + props.Hora}</p>
                </li>
                {/*props.functions.Modificacion && <li className="state-bottom">
                    <div className="row">
                        <div className="col-xs-12 text-right">
                            <button className="btn btn-secondary"
                                type="button" onClick={() => props.setUserState(props.ID, true, false)} >Recuperar</button>
                        </div>
                    </div>
                </li>*/}
            </ul>
        </div>
    );
}

export default EstadoEliminado